import React from 'react';
import styled from 'styled-components';
import Box from '@mui/material/Box';

const StyledPill = styled(Box)`
    & .plus {
    font-weight: 700;
    position: relative;
    top: -0.01rem;
    }
    &:hover {
        background-color: ${props => props.hover || 'transparent'};
        cursor: default;
    }
`;
export default function Pill ({label, className, hover}) {
    return <StyledPill className={`h5 radius-50 padding-small-x-4 padding-small-y-2 margin-small-right-2 margin-small-bottom-4 ${className}`} hover={hover}>
      <span className="plus margin-small-right-2">+</span>
      <span>{label}</span>
    </StyledPill>
}